<template>
  <div>
    <b-modal
      ref="modalExport"
      class="filterDateModal"
      scrollable
      size="sm"
      title="Filtros para exportação"
      :ok-disabled="true"
      @ok="modalOk"
    >
      <label>Tipo de exportação:</label>
      <pdf-attachment-mode
        :isForm="false"
        :model.sync="optionsExport"
      ></pdf-attachment-mode>
      <!-- <b-form-select
        v-model="optionsExport"
        id="optionsExport"
        :options="optionsExportPdf"
      >
      </b-form-select> -->
      <div v-for="field in fields" :key="field.key" class="vertical-align">
        <!-- {{field}} -->
        <div v-if="field.filterType == 'dateRange'">
          <b-form-group
            :label="field.label + ' (inicio)'"
            :label-for="field.filterKey"
          >
            <b-form-input
              :id="field.filterKey"
              type="date"
              v-model="tableFilters[field.filterKeyBegin]"
            />
          </b-form-group>
          <b-form-group
            :label="field.label + ' (fim)'"
            :label-for="field.filterKey"
          >
            <b-form-input
              :id="field.filterKey"
              type="date"
              v-model="tableFilters[field.filterKeyEnd]"
            />
          </b-form-group>
        </div>
        <div v-else-if="tableFilters[field.filterKey] != null">
          <b-form-group :label="field.label" :label-for="field.filterKey">
            <b-form-input
              :id="field.filterKey"
              v-model="tableFilters[field.filterKey]"
              :placeholder="'Buscar por ' + field.label"
            />
          </b-form-group>
        </div>
      </div>

      <b-form-group label="Registros a exportar" label-for="paginationOptions">
        <b-form-select
          v-model="paginationPerPage"
          id="paginationOptions"
          :options="paginationOptions"
        >
        </b-form-select>
      </b-form-group>
      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <b-button variant="green" @click="ok()" :disabled="isExporting">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-button size="sm" @click="modalOpen">Nova exportação</b-button>
  </div>
</template>
<script>
export default {
  name: "ChecklistFilledExportPdf",
  components: {
    PdfAttachmentMode: () =>
      import("@/components_rms/checklist/fill/PdfAttachmentMode.vue"),
  },
  props: {
    fields: Array,
    tableFilters: Object,
    // paginationPerPage: Number,
    allId: Array,
    exportType: Number,
  },
  data: function () {
    return {
      isExporting: false,
      paginationOptions: [5, 10, 25, 50, 100, 150, 500, 1000, 2500, 5000],
      optionsExportPdf: [
        { value: 0, text: "Exportação completa" },
        { value: 1, text: "Exportação sem fotos" },
        { value: 2, text: "Exportação sem campos vazios" },
        { value: 3, text: "Exportação sem fotos/sem campos vazios" },
      ],
      optionsExport: 1,
      checklistId: [],
      paginationPerPage: 10,
    };
  },
  computed: {
    getFilterFill: {
      get: function () {
        return this.dateFill;
      },
      set: function (value) {
        this.$emit("update:dateBegin", value);
        this.$emit("update:dateEnd", value);
      },
    },
    getFilterBegin: {
      get: function () {
        return this.dateBegin;
      },
      set: function (value) {
        this.$emit("update:dateBegin", value);
      },
    },
    getFilterEnd: {
      get: function () {
        return this.dateEnd;
      },
      set: function (value) {
        this.$emit("update:dateEnd", value);
      },
    },
    getFilterOption: {
      get: function () {
        return this.optionFilterDate;
      },
      set: function (value) {
        this.$emit("update:optionFilterDate", value);
      },
    },
  },
  methods: {
    modalOpen() {
      this.$refs.modalExport.show();
    },
    modalOk(bvModalEvt) {
      bvModalEvt.preventDefault();

      let apiFilter = {
        currentPage: 1,
        perPage: this.paginationPerPage,
        checklistId: this.tableFilters.checklistId,
        formName: this.tableFilters.formName,
        formSearchKey: this.tableFilters.formSearchKey,
        dateFill: this.tableFilters.dateFill,
        fillDateBegin: this.tableFilters.dateBegin,
        fillDateEnd: this.tableFilters.dateEnd,
        fillUserName: this.tableFilters.userFillName,
        checklistStatus: this.tableFilters.checklistStatus,
        exportType: this.optionsExport,
      };
      this.isExporting = true;
      this.$apiChecklist
        .post("/checklist/getAllId/", apiFilter)
        .then((response) => {
          this.checklistId = response.data;
          this.$emit("update:allId", this.checklistId);
          this.$emit("update:exportType", this.optionsExport);
          this.isExporting = false;
          this.$emit("refresh");
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
    hideModal() {
      this.$refs.modalExport.hide();
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>
